// @mui
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

// Add support for the sx prop for consistency with the other branches.
const Anchor = styled('a')({});

export default Anchor;
